<template>
    <div class="brief">
        <div class="row">
            <!-- 左边 -->
            <div class="fl w235">
                <div class="sideTitle2">
                    <div class="list-img">
                        <h5>协会动态</h5>
                    </div>
                    <div class="list">
                        <ul>
                            <li v-for="(item,index) in list" :class="isActive == index?'active': ''" :key="index"
                                @click="listClick(item.id,index)">
                                <p>{{item.text}}</p>
                                <i class="el-icon-arrow-right"></i>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="sideImg">
                    <img src="../../../assets/image/mxu.jpg" alt="">
                </div>
            </div>
            <!-- 右边 -->
            <div class="fr w750">
                <div class="pageBox2">
                    <div class="about">
                        <ul>
                            <li v-for="item in dataDynamic" :key="item.id" @click="onClickDataNotice(item)">
                                <a href="#">{{item.title}}</a>
                                <span>{{item.createTime}}</span>
                            </li>
                        </ul>
                    </div>
                    <div class="pages">
                        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" small
                            layout="prev, pager, next" :total="total">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                dataDynamic: [],
                total: 0,
                isActive: 1,
                queryParams: {
                    pageNum: 1,
                    pageSize: 15,
                },
                list: [{
                        text: '协会公告',
                        id: 1
                    },
                    {
                        text: '协会动态',
                        id: 2
                    }, {
                        text: '消毒知识和技能培训',
                        id: 3
                    }, {
						text: '消毒产品相关培训',
						id: 5
					}, {
                        text: '继教项目',
                        id: 4
                    },
					{
						text: '感控管理培训',
						id: 6
					}
                ]
            }
        },
        mounted() {
            this.getlist();
        },
        methods: {
            // 获取协会公告的列表数据
            getlist() {
                this.$axios.get('/websiteData/title/listPage?subtype=dynamic', {
                    params: this.queryParams
                }).then(res => {
                    this.dataDynamic = res.data.rows;
                    this.total = res.data.total;
                })
            },
            handleSizeChange(row) {
                this.queryParams.pageSize = row;
                this.getlist();
            },
            handleCurrentChange(row) {
                this.queryParams.pageNum = row;
                this.getlist();
            },
            onClickDataNotice(item) {
                if (item.directUrl) {
                    // 确保URL是完整的，如果不是以http开头，则添加http://
                    let url = item.directUrl;
                    if (!url.startsWith('http://') && !url.startsWith('https://')) {
                        url = 'http://' + url;
                    }
                    window.open(url, '_blank');
                } else {
                    this.$router.push({
                        path: '/focus/details',
                        query: {
                            id: item.id,
                            isActive: this.isActive,
                        }
                    })
                }
            },
            listClick(id) {
                if (id == 1) {
                    this.$router.push({
                        path: '/notice',
                    })
                } else if (id == 2) {
                    this.$router.push({
                        path: '/dynamic',
                    })
                } else if (id == 3) {
                    this.$router.push({
                        path: '/disinfectionTraining',
                    })
                } else if (id == 4) {
                    this.$router.push({
                        path: '/secondaryEducation',
                    })
                }else if(id == 5){
					this.$router.push({
						path:'/disinfectionTrainingNew'
					})
				}else if(id == 6){
					this.$router.push({
						path:'/bzd'
					})
				}
            }
        }
    }
</script>

<style lang="scss" scoped>
    .brief {
        margin: 20px 0;
        overflow: hidden;

        .row {
            width: 1000px;
            background-color: #FFF;
            margin: 0 auto;

            .w235 {
                width: 235px;
                left: -8px;

                .sideImg {
                    text-align: center;
                    padding: 20px 0;
                }
            }

            .w750 {
                width: 750px;
                position: relative;
                right: -7px;

                .pageBox2 {
                    min-height: 830px;
                    border: 1px #DDDDDD solid;
                    border-radius: 5px;
                    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12),
                        0 0 6px 0 rgba(0, 0, 0, 0.04);

                    .about {
                        padding: 45px 35px;
                        font-size: 14px;
                        line-height: 20px;
                        text-align: justify;

                        ul {
                            li {
                                height: 41px;
                                line-height: 40px;
                                overflow: hidden;
                                position: relative;
                                background: url('../../../assets/image/line.gif') bottom repeat-x;

                                a {
                                    background: url('../../../assets/image/icons.gif') left center no-repeat;
                                    font-size: 14px;
                                    padding-left: 12px;
                                }

                                span {
                                    color: #999;
                                    position: absolute;
                                    top: 0px;
                                    right: 0px;
                                    white-space: nowrap;
                                }
                            }
                        }
                    }

                    .pages {
                        padding: 20px 0;
                        display: flex;
                        justify-content: center;
                    }
                }
            }
        }
    }
</style>
